import { Box, Button, Card, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, Radio, RadioGroup, Stack, TextField, Paper, Typography, Divider, FormGroup, Checkbox, Slider } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';

let mobileScreenDetect = false
  if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(navigator.userAgent||navigator.vendor||window.opera)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test((navigator.userAgent||navigator.vendor||window.opera).substr(0,4))){
    mobileScreenDetect = true;
  }

const formatTime = (seconds) => {
  const hrs = Math.floor(seconds / 3600).toString().padStart(2, '0');
  const mins = Math.floor((seconds % 3600) / 60).toString().padStart(2, '0');
  const secs = Math.floor(seconds % 60).toString().padStart(2, '0');
  const millis = ((seconds % 1) * 1000).toFixed(0).padStart(3, '0'); // Extract milliseconds

  return `${hrs}:${mins}:${secs}:${millis}`;
};

const loadScript = (src, callback) => {
  const script = document.createElement('script');
  script.src = src;
  script.onload = callback;
  document.body.appendChild(script);
};

const loadCSS = (href) => {
  const link = document.createElement('link');
  link.href = href;
  link.rel = 'stylesheet';
  document.head.appendChild(link);
};

export const SummaryModal = ({ modalOpen, onModalCancel, onModalConfirm, modalData, videolink, intendedDuration, isAiSummaryModalActivated, setIsAiSummaryModalActivated }) => {
  const modalVideo = useRef();
  const [choosedVal, setChoosedVal] = useState(null);
  const [modalList, setModalList] = useState([]);
  const [choosedChapter, setChoosedChapter] = useState([]);
  const [chapterList, setChapterList] = useState({});
  const [chatpterTopics, setChatpterTopics] = useState([]);
  const [isCheckedAll, setIsCheckedAll] = useState(false);
  const [totalDuration, setTotalDuration] = useState('00:00:00:000');
  const [importanceValue, setImportanceValue] = useState(intendedDuration);
  const [isChronological, setIsChronological] = useState(true);
  const ProjectJSON = useSelector(store => store.projectdata.projectJSON);
  const projectDuration = (ProjectJSON?.duration / 1000) || 0;

  const [currentChapterStart, setCurrentChapterStart] = useState(null);
  const [currentChapterEnd, setCurrentChapterEnd] = useState(null);

  useEffect(() => {
    setImportanceValue(intendedDuration);
  }, [intendedDuration]);

  useEffect(() => {
    if (modalOpen) {
      // loadCSS('https://vjs.zencdn.net/7.14.3/video-js.css');
      // loadScript('https://vjs.zencdn.net/7.14.3/video.min.js', () => {
      //   initializeVideoPlayer();
      // });
    }
  }, [modalOpen, videolink]);

  const initializeVideoPlayer = () => {
    if (window.videojs && modalVideo.current) {
      window.videojs(modalVideo.current, {
        controls: true,
        autoplay: false,
        preload: 'auto',
        fluid: true,
      });
    }
  };

  useEffect(() => {
    let modalArr = [];
    const sumKeys = Object.keys(modalData);
  
    if (sumKeys.includes('chapters')) {
      const chapterData = modalData['chapters'];
      console.log('Raw Chapter Data:', chapterData);  // Log raw data
  
      let tmpChapters = {};
      Object.entries(chapterData).forEach(([key, chapterInfo]) => {
        tmpChapters[chapterInfo.topic] = {
          ...chapterInfo,
          importance: parseFloat(chapterInfo.importance)  // Assuming 'importance' is correctly formatted
        };
      });
  
      console.log('Processed Chapters:', tmpChapters);  // Log processed data
      setChapterList(tmpChapters);
      const topicKeys = Object.keys(tmpChapters);
      setChatpterTopics(topicKeys);
      setChoosedChapter(topicKeys);
      setIsCheckedAll(true);
      calculateTotalDuration(topicKeys);
      setIsAiSummaryModalActivated(true);
    }
  
    // Process other data
    sumKeys.filter(kItem => kItem !== 'chapters').forEach(kItem => {
      if (!kItem.includes('suggested')) {
        modalData[kItem].userDirect = kItem;
        modalArr.push(modalData[kItem]);
      }
    });
  
    setChoosedVal(null);
    setModalList(modalArr);
  }, [modalData]);
  
  useEffect(() => {
    const video = modalVideo.current;
    if (video) {
      video.addEventListener('timeupdate', handleTimeUpdate);
    }

    return () => {
      if (video) {
        video.removeEventListener('timeupdate', handleTimeUpdate);
      }
    };
  }, [currentChapterStart, currentChapterEnd]);

  const calculateTotalDuration = (selectedChapters) => {
    let totalSeconds = 0;
  
    // Use selected chapters, already sorted by importance, but reorder for display based on isChronological
    const displayedChapters = isChronological
      ? selectedChapters.sort((a, b) => {
          const startA = parseFloat(chapterList[a]?.new_timestamps[0].split('-')[0]);
          const startB = parseFloat(chapterList[b]?.new_timestamps[0].split('-')[0]);
          return startA - startB;
        })
      : selectedChapters;

    displayedChapters.forEach(chapter => {
      if (chapterList[chapter] && chapterList[chapter].new_timestamps) {
        const chapterDuration = calculateDuration(chapterList[chapter].new_timestamps);
        totalSeconds += parseFloat(chapterDuration);
      }
    });
  
    setTotalDuration(formatTime(totalSeconds));
  };

  const onChangeChapterOption = (topic) => {
    let tmpchoosedChapter = [];
    const currentIndex = choosedChapter.indexOf(topic);

    if (choosedChapter.includes(topic)) {
      tmpchoosedChapter = choosedChapter.filter(item => item !== topic);
      setChoosedChapter(tmpchoosedChapter);
      calculateTotalDuration(tmpchoosedChapter);
    } else {
      tmpchoosedChapter = [...choosedChapter, topic];

      // Sort the chapters chronologically before updating state
      const sortedChapters = tmpchoosedChapter.sort((a, b) => {
        const startA = parseFloat(chapterList[a]?.new_timestamps[0].split('-')[0]);
        const startB = parseFloat(chapterList[b]?.new_timestamps[0].split('-')[0]);
        return startA - startB;
      });

      setChoosedChapter(sortedChapters);
      calculateTotalDuration(sortedChapters);

      // Seek the video to the start of the selected chapter
      //modalVideo.current.play(); // Optional: Auto-play the video

      // Seek the video to the start of the selected chapter and set loop timestamps
      const chapterTimestamp = chapterList[topic].new_timestamps[0];
      const startTime = parseFloat(chapterTimestamp.split('-')[0]);
      const endTime = parseFloat(chapterTimestamp.split('-')[1]);
      setCurrentChapterStart(startTime);
      setCurrentChapterEnd(endTime);
      modalVideo.current.currentTime = startTime;
    }
    setChoosedVal(null);
  };

  const handleTimeUpdate = () => {
    const video = modalVideo.current;
    if (video.currentTime >= currentChapterEnd) {
      video.currentTime = currentChapterStart;
    }
  };

  const checkAllChapters = () => {
    if (choosedChapter.length === chatpterTopics.length) {
      setChoosedChapter([]);
      setIsCheckedAll(false);
      calculateTotalDuration([]);
    } else {
      const sortedTopics = chatpterTopics.sort((a, b) => {
        const startA = parseFloat(chapterList[a]?.new_timestamps[0].split('-')[0]);
        const startB = parseFloat(chapterList[b]?.new_timestamps[0].split('-')[0]);
        return startA - startB;
      });

      setChoosedChapter(sortedTopics);
      setChoosedVal(null);
      setIsCheckedAll(true);
      calculateTotalDuration(sortedTopics);
    }
  };

  const checkingOptions = (topic) => choosedChapter.includes(topic);

  const onClickModalConfirm = () => {
    if (choosedVal === null && choosedChapter.length < 1) return;
    if (choosedVal === null) {
      let tmpChapterItem = { new_timestamps: [] };

      // Sort the selected chapters based on the isChronological flag before confirming
      const sortedChapters = isChronological
        ? choosedChapter.sort((a, b) => {
            const startA = parseFloat(chapterList[a]?.new_timestamps[0].split('-')[0]);
            const startB = parseFloat(chapterList[b]?.new_timestamps[0].split('-')[0]);
            return startA - startB;
          })
        : choosedChapter; // Keep the original order if isChronological is false

      sortedChapters.forEach(chItem => {
        tmpChapterItem.new_timestamps.push(chapterList[chItem].new_timestamps[0]);
      });
      onModalConfirm(tmpChapterItem);
    } else {
      onModalConfirm(modalData[choosedVal]);
    }
  };

  const onModalValChanged = (e) => {
    setChoosedVal(e.target.value);
    setChoosedChapter([]);
    setIsCheckedAll(false);
    // modalVideo.current.src = `${videolink}#t=${modalData[e.target.value].new_timestamps[0].replace('-', ',')}`;
    const chapterTimestamp = modalData[e.target.value].new_timestamps[0]
    const startTime = parseFloat(chapterTimestamp.split('-')[0]);
    modalVideo.current.currentTime = startTime;
  };

  const countWords = (str) => {
    if (typeof str !== 'string') return 0;
    return str.trim().split(/\s+/).filter(word => word.length > 0).length;
  }

  function calculateDuration(timeIntervals) {
    // Ensure we have an array to work with, even if it's a single interval

    //console.log("timeIntervals : " + timeIntervals);
    const intervalsArray = Array.isArray(timeIntervals) ? timeIntervals : timeIntervals.split(',');

    //console.log("intervalsArray : " + intervalsArray);

    let totalDuration = 0;

    intervalsArray.forEach(interval => {
        const [start, end] = interval.split('-').map(Number);
        totalDuration += (end - start);
    });

    return totalDuration.toFixed(2);
  }

  const handleChronologicalChange = (event) => {
    setIsChronological(event.target.checked); // Toggle chronological sorting
    calculateTotalDuration(choosedChapter); // Recalculate total duration with the new sorting order
  };

  const onSliderChange = (event, newValue) => {
    setImportanceValue(newValue);

    let totalSeconds = 0;
    const selectedChapters = [];

    // Sort chapters by importance in descending order to select chapters
    const sortedChaptersByImportance = chatpterTopics
      .map(topic => ({
        topic,
        importance: chapterList[topic]?.importance,
        duration: parseFloat(calculateDuration(chapterList[topic].new_timestamps))
      }))
      .sort((a, b) => b.importance - a.importance);

    // Select chapters until the total duration matches the slider value
    for (const chapter of sortedChaptersByImportance) {
      if (totalSeconds + chapter.duration <= newValue) {
        selectedChapters.push(chapter.topic);
        totalSeconds += chapter.duration;
      } else {
        break;
      }
    }

    // If chronological order is enabled, sort the selected chapters chronologically for display
    const displayedChapters = isChronological
      ? selectedChapters.sort((a, b) => {
          const startA = parseFloat(chapterList[a]?.new_timestamps[0].split('-')[0]);
          const startB = parseFloat(chapterList[b]?.new_timestamps[0].split('-')[0]);
          return startA - startB;
        })
      : selectedChapters;

    // Update selected chapters and total duration
    setChoosedChapter(displayedChapters);
    setTotalDuration(formatTime(totalSeconds));
  };

  return (
    <Dialog
      open={modalOpen}
      onClose={onModalCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="xl"
      PaperProps={{ style: { minHeight: '90vh', overflowY: 'auto' } }} // Adjusted height here
      height="80vh"
      fullWidth
    >
      <DialogTitle id="alert-dialog-title">
        <Typography variant="h6" sx={{ textAlign: 'center', width: '100%' }}>
          Options for AI Summary Video
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box>
          <Card sx={{ width: '100%', padding: 1 }}>
            <Typography variant="body1">
              Chapters
            </Typography>
            <FormControlLabel label="Select all Chapters" control={<Checkbox checked={isCheckedAll} />} onClick={checkAllChapters} />
            <FormControlLabel
              label="Chronological Order"
              control={<Checkbox checked={isChronological} onChange={handleChronologicalChange} />}
            />
            <Stack direction="row" alignItems="center" spacing={2} sx={{ marginLeft: 2 }}>
              <TextField
                variant="outlined"
                size="small"
                label="AI Summary Duration"
                value={totalDuration}
                InputProps={{
                  readOnly: true,
                  sx: { textAlign: 'right' },
                }}
                sx={{ marginLeft: 2 }}
              />
              <TextField
                variant="outlined"
                size="small"
                label="Project Duration"
                value={formatTime(projectDuration)}
                InputProps={{
                  readOnly: true,
                  sx: { textAlign: 'right' },
                }}
              />
              <Box>
                <Typography gutterBottom>Intended Duration (Current: {formatTime(importanceValue)})</Typography>
                <Slider
                  value={importanceValue}
                  min={0}
                  max={projectDuration}
                  onChange={onSliderChange}
                  valueLabelDisplay="auto"
                  aria-labelledby="intended-duration-slider"
                />
                <Box display="flex" justifyContent="space-between">
                  <Typography variant="body2">Min: 00:00:00</Typography>
                  <Typography variant="body2">Max: {formatTime(projectDuration)}</Typography>
                </Box>
              </Box>
            </Stack>
            <Stack direction={'row'} spacing={1} justifyContent="flex-end" alignItems="flex-start" sx={{ width: '100%' }}>
              <Box width={'100%'} overflow={'auto'} sx={{ flexGrow: 1 }}>
                <FormGroup>
                  {chatpterTopics.map((chapterItem, key) => (
                    <Stack key={key} direction={"row"} justifyContent={"flex-start"} marginTop={1} alignItems={'start'}>
                      <Checkbox onClick={() => onChangeChapterOption(chapterList[chapterItem].topic)} checked={checkingOptions(chapterList[chapterItem].topic)} />
                      <Card sx={{ width: '100%', marginLeft: 2, padding: 1, flexGrow: 1 }}>
                        <Stack direction="row" justifyContent="space-between" alignItems="center">
                          <Typography variant="h6">{chapterList[chapterItem].topic}</Typography>
                          <Stack direction="row" alignItems="center">
                            <TextField
                              label="Importance"
                              size="small"
                              value={chapterList[chapterItem].importance || 0}
                              InputProps={
                                  { readOnly: true,
                                    sx: { mt: 2, mb: 1,
                                      textAlign: 'right',
                                      '& input': {  // Targeting the input element directly
                                      fontSize: '0.75rem'  // Set the font size smaller }}
                                    }
                                  }
                                }
                              }
                            />
                            <TextField
                              variant="outlined"
                              size="small"
                              label="Start Timestamp"
                              value={`${formatTime(parseFloat(chapterList[chapterItem].new_timestamps[0].split('-')[0]).toFixed(2)) || 0}`}
                              InputProps={
                                { readOnly: true,
                                  sx: { mt: 2, mb: 1,
                                    textAlign: 'right',
                                    '& input': {  // Targeting the input element directly
                                    fontSize: '0.75rem'  // Set the font size smaller }}
                                  }
                                }
                              }
                            }
                            />
                            <TextField
                              variant="outlined"
                              size="small"
                              label="End Timestamp"
                              value={`${formatTime(parseFloat(chapterList[chapterItem].new_timestamps[0].split('-')[1]).toFixed(2)) || 0}`}
                              InputProps={
                                { readOnly: true,
                                  sx: { mt: 2, mb: 1,
                                    textAlign: 'right',
                                    '& input': {  // Targeting the input element directly
                                    fontSize: '0.75rem'  // Set the font size smaller }}
                                  }
                                }
                              }
                            }
                            />
                            <TextField
                              variant="outlined"
                              size="small"
                              label="Words"
                              value={`${countWords(chapterList[chapterItem].new_transcript) || 0}`}
                              InputProps={
                                { readOnly: true,
                                  sx: { mt: 2, mb: 1,
                                    textAlign: 'right',
                                    '& input': {  // Targeting the input element directly
                                    fontSize: '0.75rem'  // Set the font size smaller }}
                                  }
                                }
                              }
                            }
                            />
                            <TextField
                              variant="outlined"
                              size="small"
                              label="Duration (secs)"
                              value={`${formatTime(calculateDuration(chapterList[chapterItem].new_timestamps))}`}
                              InputProps={
                                { readOnly: true,
                                  sx: { mt: 2, mb: 1,
                                    textAlign: 'right',
                                    '& input': {  // Targeting the input element directly
                                    fontSize: '0.75rem'  // Set the font size smaller }}
                                  }
                                }
                              }
                            }
                            />
                          </Stack>
                        </Stack>
                        <Typography variant="body1">{chapterList[chapterItem].comment}</Typography>
                        <Typography variant="body2">[{chapterList[chapterItem].new_transcript}]</Typography>
                      </Card>
                    </Stack>
                  ))}
                </FormGroup>
              </Box>
              {!mobileScreenDetect &&
              <Box width={'50%'} maxHeight={'350px'} display="flex" justifyContent="flex-end">
                <video
                  ref={modalVideo}
                  preload="auto"
                  controls
                  className="video-js vjs-default-skin"
                  src={videolink}
                  style={{
                    width: '100%',
                    height: '100%',
                    maxHeight: '350px',
                    objectFit: 'contain' // This will ensure the video fits within the box, maintaining its aspect ratio
                  }}
                />
              </Box>
              }
            </Stack>
          </Card>
        </Box>
        <Divider />
      </DialogContent>
      <DialogActions>
        <Button onClick={onModalCancel}>Cancel</Button>
        <Button onClick={onClickModalConfirm} autoFocus>
          Create AI Summary
        </Button>
      </DialogActions>
    </Dialog>
  );
};
